<template>
    <v-container class="pa-0">
        <v-container
            class="d-flex justify-space-between align-center"
            :class="{ 'px-custom': !isMobile && !isTablet }"
        >
            <div class="d-flex align-center gap-3">
              <img
                v-if="appUserInfo != null && appUserInfo != undefined"
                :src="appUserInfo.logo != null ? appUserInfo.logo.link : require('@/assets/abriron.png')"
                style="width: 50px;"
              />
              <img
                v-else
                :src="userInfo?.init?.logo?.link"
                style="width: 50px;"
              />
              <div v-if="appUserInfo != null && appUserInfo != undefined">
                  <v-card-text class="pa-0 text-body-1">
                    {{ appUserInfo.abrName ? appUserInfo.abrName : this.$t('dear-user') }}
                  </v-card-text>
                  <v-card-text class="pa-0 text-caption">
                    {{
                      appUserInfo.mobile ? appUserInfo.mobile :
                      appUserInfo.phone ? appUserInfo.phone :
                      this.$t('user-phone-number')
                    }}
                  </v-card-text>
              </div>
              <div v-else>
                  <v-card-text class="pa-0 text-body-1">{{ userInfo?.init?.abrName }}</v-card-text>
                  <v-card-text class="pa-0 text-caption">{{ userInfo?.init?.user?.mobile  }}</v-card-text>
              </div>
            </div>
            <div
              class="mt-1"
              @click="$router.push({ name: 'Dashboard' })"
              style="cursor: pointer;"
            >
              <img src="@/assets/plans/abriron.png" />
            </div>
        </v-container>
    </v-container>
</template>

<script>
export default {
  props: {
    appUserInfo: Object
  },
  data () {
    return {
      userInfo: null
    }
  },
  mounted () {
    this.userInfo = JSON.parse(localStorage.getItem('token'))
  }
}
</script>

<style scoped>
.px-custom {
    padding-left: 150px !important;
    padding-right: 150px !important;
}
</style>
